<template>
  <div class="search-input">
    <b-form-input
      :value="value"
      size="sm"
      class="search-input__field"
      :placeholder="placeholder"
      :maxlength="maxLength"
      autocomplete="off"
      :data-cy="dataCy"
      @input="$emit('input', $event)"
      @keydown.enter.prevent="$emit('submit')"
    />

    <button
      v-if="value"
      type="button"
      class="search-input__clear"
      aria-label="Clear search"
      title="Clear search"
      :data-cy="`${dataCy}-clear`"
      @click="$emit('clear')"
    >
      <font-awesome-icon :icon="['fas', 'times']" />
    </button>
  </div>
</template>

<script>
import { BFormInput } from 'bootstrap-vue'

/**
 * A text box with a clear "x". It only reports: `input` per keystroke, `submit` on Enter and `clear` on the
 * "x"; when the text applies (debounce) is the parent's call.
 */
export default {
  name: 'SearchInput',

  components: {
    BFormInput
  },

  props: {
    value: {
      type: String,
      default: ''
    },

    placeholder: {
      type: String,
      default: 'Search'
    },

    maxLength: {
      type: Number,
      default: null
    },

    dataCy: {
      type: String,
      default: 'search-input'
    }
  },
}
</script>

<style lang="scss" scoped>
.search-input {
  position: relative;
}

// Room for the "x" so long text doesn't run under it
.search-input__field {
  padding-right: 1.75rem;
}

.search-input__clear {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  padding: 0;
  border: 0;
  background: transparent;
  color: $secondary;
  line-height: 1;
  cursor: pointer;
}
</style>
